export const storeConfig = {
    storeKey: 'unboxcreator-main',
    coupons: [
        { code: 'UNBOX10', discount: 0.10, description: '10% de réduction' },
        { code: 'VIP20', discount: 0.20, description: '20% de réduction VIP' },
        { code: 'DEBUG50', discount: 0.50, description: '50% de réduction (TEST)' },
        { code: 'LAUNCH10', discount: 0.10 }
    ],
    shipping: {
        freeThreshold: 50,
        standardCost: 4.90
    },
    contact: {
        email: 'hello@unboxcreator.com',
        phone: '+33 1 23 45 67 89'
    }
};
